import { render, staticRenderFns } from "./List.vue?vue&type=template&id=20f82ac4&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./List.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20f82ac4')) {
      api.createRecord('20f82ac4', component.options)
    } else {
      api.reload('20f82ac4', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=20f82ac4&", function () {
      api.rerender('20f82ac4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DeliveryNote/DeliveryDetailsQuery/List.vue"
export default component.exports